import React, { useContext, useEffect } from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import IconButton from "@mui/material/IconButton";
import leftPanelOpen from "../../../../assets/left_panel_open.svg";
import leftPanelClose from "../../../../assets/left_panel_close.svg";
import styles from "./chatHistoryPanel.module.scss";
import HistoryTab from "./historyOld";
import Typography from "../../typography/Typography";
import { StateContext } from "../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../context/globalContext/interface";
import { useHistoryContext } from "../../../../context/historyContext/historyContext";
import { iHistoryContext } from "../../../../context/historyContext/interface";
import { fsPx } from "../../../../styles/design-tokens";

interface ChatHistoryPanelProps {
  variant: "desktop" | "mobileDrawer";
  collapsed?: boolean;
  onToggleCollapse?: () => void;
  onNewChat: () => void;
  showPublicChat?: boolean;
  onPublicChat?: () => void;
  setIsOpenMobileSidebar?: (value: boolean) => void;
}

const ChatHistoryPanel: React.FC<ChatHistoryPanelProps> = ({
  variant,
  collapsed = false,
  onToggleCollapse,
  onNewChat,
  showPublicChat = false,
  onPublicChat,
  setIsOpenMobileSidebar,
}) => {
  const { userInfo }: iGlobalContext = useContext(StateContext);
  const { getHistory }: iHistoryContext = useHistoryContext();
  const isDesktop = variant === "desktop";

  useEffect(() => {
    if (userInfo?.loggedIn) getHistory(true, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isDesktop && collapsed) {
    return (
      <IconButton type="button" className={styles.reopenBtn} aria-label="Open chat history" onClick={onToggleCollapse}>
        <img src={leftPanelOpen} alt="" className={`${styles.toggleIcon} zv-icon`} />
      </IconButton>
    );
  }

  return (
    <div className={`${styles.panel} ${isDesktop ? styles.panelDesktop : styles.panelMobile}`}>
      <div className={styles.header}>
        <div className={styles.headerRow}>
          <button type="button" className={styles.newChatBtn} onClick={onNewChat}>
            <AddOutlinedIcon className={styles.pillIcon} sx={{ fontSize: fsPx(16) }} />
            <Typography variant="span" size="size14" weight={500} color="neutralDarkest" className={styles.pillLabel}>
              New chat
            </Typography>
          </button>
          {isDesktop && onToggleCollapse && (
            <IconButton
              type="button"
              className={styles.collapseBtn}
              aria-label="Collapse chat history"
              onClick={onToggleCollapse}
            >
              <img src={leftPanelClose} alt="" className={`${styles.toggleIcon} zv-icon`} />
            </IconButton>
          )}
        </div>
        {showPublicChat && onPublicChat && (
          <button type="button" className={styles.publicChatBtn} onClick={onPublicChat}>
            <PublicOutlinedIcon className={styles.pillIcon} sx={{ fontSize: fsPx(16) }} />
            <Typography variant="span" size="size14" weight={500} color="neutralDarkest" className={styles.pillLabel}>
              Public chat
            </Typography>
          </button>
        )}
      </div>
      <div className={styles.listWrap}>
        <HistoryTab setIsOpenMobileSidebar={setIsOpenMobileSidebar} embedded />
      </div>
    </div>
  );
};

export default ChatHistoryPanel;
